import MyStepTypes from './mystep.types';
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import { clearLocalStorage } from '../../utils/commonFunctions';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';

function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function* fetchMyStepDetails() {
	try {
		const res = yield call(Api, {
			url: 'mystep',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: MyStepTypes.FETCH_MYSTEP_DETAILS.SUCCESS,
					payload: res.data,
				});
				if (
					!!localStorage.getItem('onboardPending') &&
					localStorage.getItem('onboardPending') === '0'
				) {
					yield put(push('/onboard/step1'));
				}
				//yield put({ type: MyStepTypes.UPDATE_ACTIVE_COURSE, payload: res.data.active_course_id });
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mystep', err);
	}
}

function* fetchReport() {
	try {
		const res = yield call(Api, {
			url: 'detailreport',
			method: 'GET',
			headers: { 'access-token': localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				yield put({
					type: MyStepTypes.FETCH_REPORT.SUCCESS,
					payload: res.data.file_url,
				});
				window.open(res.data.file_url, '_blank');
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('mystep', err);
	}
}

function* fetchMyStepDetailsStart() {
	yield takeLatest(MyStepTypes.FETCH_MYSTEP_DETAILS.PENDING, fetchMyStepDetails);
}

function* fetchReportStart() {
	yield takeLatest(MyStepTypes.FETCH_REPORT.PENDING, fetchReport);
}

export function* mystepSagas() {
	yield all([call(fetchMyStepDetailsStart), call(fetchReportStart)]);
}
